import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { URLs } from "../../Constants/Consts";
import { fetchApi } from "../../Helpers/Functions";
import { addUsers } from "../../store/Users";
import { updateDownloadTriggered, updateHasDownloadedValue } from "../../store/Utilities";
import { RootState } from "../../store/store";
import { AssignmentApiData, UserAssignment } from "../../types/types";
import { ROLES } from "../../utils/roles";

export default function storeAllUsers() {
    const disciplines = useSelector((state: RootState) => state.Discipline.allDisciplines)
    const projects = useSelector((state: RootState) => state.Project.projects)
    const accessLevels = useSelector((state: RootState) => state.AccessLevel.AccessLevels)
    const dispatch = useDispatch()
    const SelectedUser = useSelector(
        (state: RootState) => state.SelectedUser.SelectedUser
    );
    
    const admin = SelectedUser.role === ROLES.SuperAdmin || SelectedUser.role === ROLES.Admin || SelectedUser.role === ROLES.AdminManager;
    const { downloadTriggered: { allUsers: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    
    const [isLoading, setIsLoading] = useState(false)
    const calledOnceRef = useRef(false)

    useEffect(() => {
        (async () => {
            if (!admin && triggered) {
                // only chain downloading comments
                dispatch(updateDownloadTriggered({ key: "comments", value: true }))
                dispatch(updateDownloadTriggered({ key: "allUsers", value: false }))
                return
            }
            if (SelectedUser.jwt && triggered && projects.length && disciplines.length) {
                calledOnceRef.current = true
                setIsLoading(true)
                const usersAssignments = await fetchApi(URLs.getAssignmentsUrl()).then(res => res.json()) as Array<AssignmentApiData>
                const tableData = usersAssignments.map(ua => {
                    // Use accessLevelName from assignment as role
                    const accessLevelName = accessLevels.find(al => al.accessLevelId === ua.accessLevelId)?.accessLevelName;
                    return {
                        ...ua,
                        project: projects.find(p => p.projectNumber === ua.projectNumber)?.projectName ?? '',
                        discipline: disciplines?.find(d => d.disciplineId === ua.disciplineId)?.disciplineName ?? '',
                        accessLevelName: accessLevelName,
                        role: accessLevelName ?? 'User', // Use accessLevelName as the role
                    }
                }) as Array<UserAssignment>
                dispatch(addUsers(tableData))
                dispatch(updateHasDownloadedValue({ key: "allUsers", value: true }))
                dispatch(updateDownloadTriggered({ key: "allUsers", value: false }))
                setIsLoading(false)
                // chain downloading comments
                dispatch(updateDownloadTriggered({ key: "comments", value: true }))
            }
        })()

    }, [SelectedUser.jwt, triggered, disciplines, projects, accessLevels])

    return { isLoading }
}

